import { h as __h } from "preact";
/** @import { InputHTMLAttributes } from "preact"; */

import html from "~/util/html.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Switch.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Switch.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {boolean} checked
 * @property {string} [id]
 * @property {boolean} [disabled]
 * @property {boolean} [loading]
 */

/** @param {Props & InputHTMLAttributes<HTMLInputElement>} props */
export default function Switch(props) {
  const {
    checked,
    id,
    disabled,
    loading,
    ...rest
  } = props;
  return __h("span", {
    "class": css.switch
  }, __h("input", {
    type: "checkbox",
    "class": css.input,
    id: id,
    checked: checked,
    disabled: loading || disabled,
    "data-loading": loading,
    ...rest
  }), __h("span", {
    "class": css.track
  }, __h("span", {
    "class": css.thumb
  })));
}